'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.eventService', [])

.factory('eventService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/API/Event';

    // Get EvebtGriyo By EventGroupID
    service.getEventGroupByEventGroupID = function (eventGroupId) {
        return $http.get(baseUrl + '/Group/' + eventGroupId)
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Search Event Groups
    service.searchEventGroups = function (nbToDisplay,
                                          page,
                                          employeeId,
                                          isInError,
                                          isCompleted,
                                          eventTypeFacetId,
                                          environmentToSearchFor) {
        return $http.get(baseUrl + '/Group/Search', {
                        params: {
                            nbToDisplay: nbToDisplay,
                            page: page,
                            employeeId: employeeId,
                            isInError: isInError,
                            isCompleted: isCompleted,
                            eventTypeFacetId: eventTypeFacetId,
                            environmentToSearchFor: environmentToSearchFor
                        }
                    })
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Get Event
    service.getEvent = function (eventId) {
        return $http.get(baseUrl + '/' + eventId)
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Resubmit Event
    service.resubmitEvent = function (eventId) {
        return $http.post(baseUrl + '/' + eventId + '/Resubmit')
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Confirm Event
    service.confirmEvent = function (eventId) {
        return $http.post(baseUrl + '/' + eventId + '/Confirm')
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Reject Event
    service.rejectEvent = function (eventId) {
        return $http.post(baseUrl + '/' + eventId + '/Reject')
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Ignore Event
    service.ignoreEvent = function (eventId) {
        return $http.post(baseUrl + '/' + eventId + '/Ignore')
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Continue Process After Pending Event
    service.continueProcessAfterPendingEvent = function (eventId) {
        return $http.post(baseUrl + '/' + eventId + '/ContinueProcessAfterPendingEvent')
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Continue Process After Ignoring Pending Event
    service.continueProcessAfterIgnoringPendingEvent = function (eventId) {
        return $http.post(baseUrl + '/' + eventId + '/ContinueProcessAfterIgnoringPendingEvent')
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Create Event For Test Echo Adss
    service.createEventForTestEchoAdss = function () {
        return $http.post(baseUrl + '/Test/ADSS/Echo')
                    .then(function (response) {
                        return response.data;
                    });
    };

    return service;
}]);
